import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_auth/_app/subjects/$id/samples")({
  validateSearch: (search) => {
    return z
      .object({
        sampleId: z.coerce.number().optional(),
      })
      .parse(search);
  },
});
